var React = require('react');

function Hero (props) {
    return React.createElement("svg",props,[React.createElement("path",{"style":{"fill":"var(--illu-green--main)"},"d":"M625,1093.9c-17.05,34.15-44.6,63.57-78.5,87.58C412.57,1276,196.16,1272,98.2,1147-45.22,964.09-9.51,703.43,101.41,614.86c107.68-86,285.84-5.72,463.86,186.14C647.84,889.93,662,1019.53,625,1093.9Z","transform":"translate(-3.87 -3.14)","key":0}),React.createElement("path",{"style":{"fill":"var(--illu-red--main)"},"d":"M1918.19,738.07c-31.62,31.28-73.06,53.51-119.46,67.2-183.1,54-451-19.54-512.18-194.18C1197,355.38,1364.63,69.47,1520.22,13.34c151-54.47,405.73,113,465.26,412.16C2013,563.61,1987,669.94,1918.19,738.07Z","transform":"translate(-3.87 -3.14)","key":1})]);
}

Hero.defaultProps = {"viewBox":"0 0 1992.4 1244.03"};

module.exports = Hero;

Hero.default = Hero;
